import actionCreators from './actionCreators';

import api from 'media-base-ui/utils/teamStoryAPI';

const fetchTeamStory = (args, partyKey) => async dispatch => {
    dispatch(actionCreators.requestTeamStory(args, partyKey));
    try {
        const teamStory = await api.fetchTeamStories(args);
        dispatch(actionCreators.teamStoryResponse(true, [], teamStory?.data || [], partyKey));
    }
    catch (errors) {
        console.log(errors);
        dispatch(actionCreators.teamStoryResponse(false, errors, [], partyKey));
    }
};

const fetchTeamStoryDetails = (args, partyKey) => async dispatch => {
    dispatch(actionCreators.requestTeamStoryDetail(args, partyKey));
    try {
        const { data } = await api.fetchTeamStoryDetails(args);
        dispatch(actionCreators.teamStoryDetailResponse(true, [], data[0] || {}, partyKey));
    }
    catch (errors) {
        dispatch(actionCreators.teamStoryDetailResponse(false, errors, [], partyKey));
    }
};

export default {
	fetchTeamStory,
    fetchTeamStoryDetails,
}